import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { HashLocationStrategy, LocationStrategy } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { BrowserModule } from '@angular/platform-browser'
import { DefaultUrlSerializer, RouterModule, UrlSerializer, UrlTree } from '@angular/router'
import { ConfirmationService, MessageService } from 'primeng/api'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { ClientErrorHandler } from './core/interceptors/client-error.interceptor'

import { MenuService } from './layout/services/menu.service'


import { AppConfigService } from './shared/services/app-config.service'
import { ThemeService } from './shared/services/app-theme.service'
import { CurrentUserService } from './shared/services/current-user.service'
import { MessageBusService } from './shared/services/message-bus.service'

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const path = url.split('?')[0]
    const query = url.split('?')[1] || ''
    const thing = path.toLowerCase() + (query !== '' ? `?${query}` : '')
    return super.parse(thing)
  }
}


